import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
// @ts-ignore
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
// @ts-ignore
import BcTable from '@/components/Table.vue';
const { EleResize } = require('@/assets/js/eresize.js');
let FaultKanban = class FaultKanban extends Vue {
    constructor() {
        super();
        this.searchOptions = {
            deviceType: '',
            quickly: '',
            bindingType: 0,
            queryYear: '',
            deviceMode: '',
            deviceModeId: ''
        };
        this.snackbar = new CBcSnackbar();
        // 故障数量统计表格
        this.faultCountTable = {
            data: []
        };
        // 故障阶段分类统计表格
        this.faultCategoryTable = {
            data: []
        };
        // 故障状态统计表格
        this.faultStatusTable = {
            data: []
        };
        this.pageLoading = false;
        const that = this;
    }
    async mounted() {
        const that = this;
        await that.fetchMalfunctionCatalog();
        if (!that.searchOptions.queryYear) {
            that.searchOptions.queryYear = (that.malfunctionYears.length ? Math.max(...that.malfunctionYears) : new Date().getFullYear()).toString();
        }
        if (!that.listSerial || !that.listSerial.length) {
            await that.getSerialList().then((ser) => {
                if (!that.listSerial.length) {
                    that.snackbar.error('获取设备机型为空，请联系管理员');
                }
            });
        }
        if (!this.searchOptions.deviceModeId) {
            this.searchOptions.deviceModeId = 'tab-' + this.listSerial[0].id;
        }
        await that.getList();
    }
    onSelectedTabChange(newVal, oldVal) {
        if (newVal) {
            const deviceModeId = newVal.split('-').pop();
            this.searchOptions.deviceMode = this.listSerial.find(c => c.id == deviceModeId).serial || '';
        }
        this.getList();
    }
    // 初始化数据
    async getList() {
        const that = this;
        const params = {
            startDate: that.searchOptions.queryYear ? that.searchOptions.queryYear + '-01-01' : '',
            endDate: that.searchOptions.queryYear ? that.searchOptions.queryYear + '-12-31' : '',
            deviceMode: that.searchOptions.deviceMode || this.listSerial[0].serial,
        };
        try {
            const res = await that.axios.get('/api/report/malfunction/kanban', { params: params });
            if (!res.data || !res.data.result || (typeof res.data.result !== 'object')) {
                this.snackbar.error(`查询数据出错：${res.data.result || ''}`);
                return;
            }
            const resData = res.data.result || [];
            const failureCountData = resData.failureCountData.result || [];
            const failureSortData = resData.failureSortData.result || [];
            const failureStatusData = resData.failureStatusData.result || [];
            this.faultCountTable.data = [];
            this.faultCategoryTable.data = [];
            this.faultStatusTable.data = [];
            for (let index = 1; index < 13; index++) {
                const dataInfo = failureCountData.find((it) => parseInt(it.formattMonth) === index);
                const data = {
                    modeCode: that.searchOptions.deviceMode,
                    formattMonth: index + '月',
                    noDispenFailureCount: dataInfo && dataInfo.noDispenFailureCount || 0,
                    dispenFailureCount: dataInfo && dataInfo.dispenFailureCount || 0,
                    failureAllCount: dataInfo && dataInfo.failureAllCount || 0,
                };
                this.faultCountTable.data.push(data);
            }
            for (let index = 1; index < 13; index++) {
                const dataInfo = failureSortData.find((it) => parseInt(it.formattMonth) === index && it.failureStage === '初始故障');
                const dataAccInfo = failureSortData.find((it) => parseInt(it.formattMonth) === index && it.failureStage === '偶然故障');
                const dataLossInfo = failureSortData.find((it) => parseInt(it.formattMonth) === index && it.failureStage === '损耗故障');
                const data = {
                    modeCode: that.searchOptions.deviceMode,
                    formattMonth: index + '月',
                    initialCount: dataInfo && dataInfo.initCount || 0,
                    accidentalCount: dataAccInfo && dataAccInfo.accidentalCount || 0,
                    lossCount: dataLossInfo && dataLossInfo.lossCount || 0,
                };
                this.faultCategoryTable.data.push(data);
            }
            const statusList = ['已完成', '待处理', '待验证', '暂处理'];
            for (let index = 1; index < 5; index++) {
                const dataInfo = failureStatusData.find((it) => it.status === statusList[index - 1]);
                const data = {
                    modeCode: that.searchOptions.deviceMode,
                    status: statusList[index - 1],
                    faultCount: dataInfo && dataInfo.times || 0,
                };
                this.faultStatusTable.data.push(data);
            }
            const faultCountList = that.faultCountTable.data.map((item) => item.failureAllCount);
            this.initDeviceMonthCount(faultCountList);
            this.deviceFailureCategory();
            this.deviceFailureStatus();
        }
        catch (error) {
            this.snackbar.error(`查询数据出错：${error || ''}`);
        }
    }
    // 单个设备每月故障数量
    async initDeviceMonthCount(resData) {
        const that = this;
        const datas = resData;
        if (!resData || !resData.length) {
            for (let i = 1; i < 13; i++) {
                datas.push(0);
            }
        }
        const xData = [];
        for (let i = 1; i < 13; i++) {
            xData.push(i + '月');
        }
        that.$nextTick(() => {
            const eles = that.$refs.faultCountCharts;
            if (eles) {
                const echartsDom = (eles && eles[0]) || eles;
                const charts = that.$echarts.init(echartsDom);
                if (!charts) {
                    return;
                }
                charts.showLoading();
                const option = {
                    title: {
                        text: `${this.searchOptions.deviceMode}每月故障总数量`
                    },
                    color: ['#3F51B5'],
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {},
                    toolbox: {
                        show: true,
                        feature: {
                            // dataZoom: {
                            //   yAxisIndex: 'none'
                            // },
                            dataView: { readOnly: false },
                            magicType: { type: ['line', 'bar'] },
                            restore: {},
                            saveAsImage: {}
                        }
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: true,
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            formatter: '{value}'
                        }
                    },
                    grid: {
                        bottom: 30,
                        left: 50
                    },
                    series: [
                        {
                            name: '',
                            type: 'line',
                            data: datas || [],
                            markPoint: {
                                data: [
                                    { type: 'max', name: 'Max' },
                                    { type: 'min', name: 'Min' }
                                ],
                            },
                        },
                    ]
                };
                charts.setOption(option);
                charts.hideLoading();
                EleResize.on(echartsDom, () => charts.resize());
            }
        });
    }
    // 设备故障分类统计
    deviceFailureCategory() {
        const that = this;
        that.$nextTick(() => {
            const eles = that.$refs.deviceFailure_category;
            if (eles) {
                const echartsDom = (eles && eles[0]) || eles;
                const charts = that.$echarts.init(echartsDom);
                if (!charts) {
                    return;
                }
                charts.showLoading();
                const xAxisData = [];
                for (let i = 1; i < 13; i++) {
                    xAxisData.push(i + '月');
                }
                const initData = that.faultCategoryTable.data.map((item) => item.initialCount);
                const accidentalData = that.faultCategoryTable.data.map((item) => item.accidentalCount);
                const lossData = that.faultCategoryTable.data.map((item) => item.lossCount);
                const emphasisStyle = {
                    itemStyle: {
                        shadowBlur: 5,
                        shadowColor: 'rgba(0,0,0,0.3)',
                        barWidth: 10,
                        barMaxWidth: 5
                    }
                };
                const option = {
                    title: {
                        text: `${this.searchOptions.deviceMode}故障阶段分类统计`
                    },
                    color: ['#5470C6', '#73C0DE', '#FAC858'],
                    legend: {
                        data: ['初始故障', '偶然故障', '损耗故障'],
                        left: '5%',
                        top: '10%'
                    },
                    toolbox: {
                        feature: {
                            magicType: {
                                type: ['stack']
                            },
                            dataView: {}
                        }
                    },
                    tooltip: {},
                    xAxis: {
                        data: xAxisData,
                        name: '月份',
                        axisLine: { onZero: true },
                        splitLine: { show: false },
                        splitArea: { show: false }
                    },
                    yAxis: {},
                    grid: {
                        bottom: 30,
                        left: 50
                    },
                    series: [
                        {
                            name: '初始故障',
                            type: 'bar',
                            stack: 'one',
                            emphasis: emphasisStyle,
                            data: initData
                        },
                        {
                            name: '偶然故障',
                            type: 'bar',
                            stack: 'one',
                            emphasis: emphasisStyle,
                            data: accidentalData
                        },
                        {
                            name: '损耗故障',
                            type: 'bar',
                            stack: 'one',
                            emphasis: emphasisStyle,
                            data: lossData
                        }
                    ]
                };
                charts.setOption(option);
                charts.hideLoading();
                EleResize.on(that.$refs.deviceFailure_category, () => charts.resize());
            }
        });
    }
    // 设备故障状态统计
    deviceFailureStatus() {
        const that = this;
        const data = this.faultStatusTable.data.map((item) => ({
            name: item.status,
            value: parseInt(item.faultCount) || 0
        }));
        that.$nextTick(() => {
            const eles = that.$refs.deviceFailure_status;
            if (eles) {
                const echartsDom = (eles && eles[0]) || eles;
                const charts = that.$echarts.init(echartsDom);
                if (!charts) {
                    return;
                }
                charts.showLoading();
                const option = {
                    color: ['#5470C6', '#EE6666', '#73C0DE', '#FAC858', '#4CAF50'],
                    title: {
                        text: `${this.searchOptions.deviceMode}故障状态`,
                        subtext: `${this.searchOptions.queryYear}年`,
                        left: 'left'
                    },
                    tooltip: {
                        trigger: 'item'
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'right'
                    },
                    series: [
                        {
                            name: '故障状态',
                            type: 'pie',
                            radius: '50%',
                            data: data,
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                },
                            },
                            label: {
                                show: true,
                                formatter: '{b} ({d}%)'
                            }
                        }
                    ]
                };
                charts.setOption(option);
                charts.hideLoading();
                EleResize.on(that.$refs.deviceFailure_category, () => charts.resize());
            }
        });
    }
    getSerialList() {
        const that = this;
        return that.fetchDeviceSerialList().then(() => {
        }).catch((e) => {
            console.log('error of get device serial: ', e);
            that.snackbar.error('获取设备机型列表出错');
        });
    }
};
__decorate([
    Getter
], FaultKanban.prototype, "malfunctionYears", void 0);
__decorate([
    Getter('deviceSerialList')
], FaultKanban.prototype, "listSerial", void 0);
__decorate([
    Getter
], FaultKanban.prototype, "userInfo", void 0);
__decorate([
    Getter
], FaultKanban.prototype, "deviceTypeList", void 0);
__decorate([
    Getter
], FaultKanban.prototype, "isSrvTestEnv", void 0);
__decorate([
    Action
], FaultKanban.prototype, "fetchDevices", void 0);
__decorate([
    Action
], FaultKanban.prototype, "fetchDeviceSerialList", void 0);
__decorate([
    Action
], FaultKanban.prototype, "fetchMalfunctionCatalog", void 0);
__decorate([
    Watch('searchOptions.deviceModeId')
], FaultKanban.prototype, "onSelectedTabChange", null);
FaultKanban = __decorate([
    Component({
        name: 'FaultKanban',
        data: () => ({
            formRules: {
                // @ts-ignore
                days: [v => !!v || '请输入天数', v => (/^\d+$/i.test(v)) || '请输入具体天数'],
                // @ts-ignore
                notEmpty: [v => !!v || '该字段为必填项'],
            }
        }),
        components: {
            BcTable,
            BcSnackbar,
        }
    })
], FaultKanban);
export default FaultKanban;
;
